import { useFlags } from "launchdarkly-react-client-sdk";
import { FLAGS, type FlagValues } from "./flags";

export function useFeatureFlags(): FlagValues {
  const ldFlags = useFlags<Partial<FlagValues>>();

  return {
    ...FLAGS,
    ...ldFlags,
  };
}
